import { RESOURCE_NAME as GUEST_PARKINGS } from '@esentai/core/features/guestParkings/consts';
import { permit } from '@esentai/core/policy-dsl';

import { GUEST_PARKING } from '@/features/guestParkingPage/consts/permissions';

export default [permit(GUEST_PARKINGS, [GUEST_PARKING])];
